/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createListOrderEmailsResponseFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type ListOrderEmailsResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/orders/{-id}/emails
 */
export interface EmailsRequestBuilder extends BaseRequestBuilder<EmailsRequestBuilder> {
    /**
     * Returns the emails sent about an order — its receipts to the customer, sales reps and organization, and any manual re-sends — with each one's latest delivery status and bounce reason, newest first. At most 100 are returned. An order with no emails yet returns an empty list.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ListOrderEmailsResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {ErrorResponse} error when the service returns a 404 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ListOrderEmailsResponse | undefined>;
    /**
     * Returns the emails sent about an order — its receipts to the customer, sales reps and organization, and any manual re-sends — with each one's latest delivery status and bounce reason, newest first. At most 100 are returned. An order with no emails yet returns an empty list.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const EmailsRequestBuilderUriTemplate = "{+baseurl}/api/orders/{%2Did}/emails";
/**
 * Metadata for all the requests in the request builder.
 */
export const EmailsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: EmailsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createListOrderEmailsResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
